// Colunas técnicas módulo+papel da planilha de grupos (decisões G3/G4).
// Headers canônicos, IDÊNTICOS nos 3 idiomas — nunca traduzir (como enum).
// Apenas engagement/growth/performance × manager/member/follower — NUNCA
// enviar roles de management. A ordem espelha o export do sync-backend
// (GROUP_MODULE_ROLE_COLUMNS em exports.helper.ts).
const GROUP_MODULES = ['engagement', 'growth', 'performance']
const GROUP_ROLE_TYPES = ['managers', 'members', 'followers']

const GROUP_MODULE_ROLE_COLUMNS = GROUP_MODULES.reduce((columns, module) => {
  GROUP_ROLE_TYPES.forEach(roleType => columns.push(`${roleType}_${module}`))
  return columns
}, [])

export { GROUP_MODULES, GROUP_ROLE_TYPES, GROUP_MODULE_ROLE_COLUMNS }
